angular.module("app").directive("editor", [
    '$timeout',
    function ($timeout) {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (scope, element, attrs, ngModel) {
                var editorName = attrs.id || "editor",
                    editor = CKEDITOR.replace(editorName, {extraPlugins: 'imageuploader,spoiler,simpleImageUpload'});
                    seted = false,
                    watcher = function () {};

                attrs.editor && (watcher = attrs.$observe(editorName, function (val) {
                    if (!!val && !seted) {
                        seted = true;
                        setValue();
                    }
                })) || setValue();

                editor.on("change", function (evt) {
                    $timeout(function () {
                        ngModel.$setViewValue(evt.editor.getData())
                    })
                });

                function setValue () {
                    watcher();
                    editor.setData(ngModel.$modelValue || ngModel.$viewValue || "");
                    editor.fire('mode');
                }

                scope.$on("force:reset:editor", function () {
                    $timeout(setValue)
                })
            }
        }
    }
]);
